/* jshint esversion: 6 */
import React, { useState, useEffect } from 'react';
import SortableList, { SortableItem } from 'react-easy-sort';
import ErrorThumbnail from 'app/components/PostingTool/Accessories/ErrorThumbnail.jsx';

const ThumbnailList = (props) => {
    const [ imageList, setImageList ] = useState([]);

    useEffect(() => {
        if (props.hashes.length) {
            let nextImageList = [...props.hashes];
            setImageList(nextImageList);
        }
    }, [props.hashes]);

    return (
        <SortableList
            onSortEnd={props.onDragEnd}
            className="image-list"
            draggedItemClassName="is-dragging">
            {imageList.map((hash) => {
                let imageData = props.imageData.find((media) => { return media.hash === hash; }),
                    thumbClass = (props.selectedImage === hash) ? 'editor-thumb selected' : 'editor-thumb unselected';

                if (!imageData) {
                    return null;
                }

                let thumb = (
                    <div className={thumbClass}>
                        <div className="remove-thumb" onMouseDown={props.removeMedia} data-hash={hash} role="button" aria-label="Remove Image" >
                            <i className="fa fa-times-circle"></i>
                        </div>
                        <div className="thumb-click" data-hash={hash} onMouseDown={props.onThumbClick}>
                            <img src={imageData.thumb}/>
                        </div>
                    </div>
                );

                let mediaErrors = props.mediaHashHasErrors(hash, props.accessoryServiceId);
                if (mediaErrors.length) {
                    thumb = (
                        <ErrorThumbnail
                            hash={hash}
                            errorThumb={imageData}
                            file={imageData.name}
                            error={mediaErrors}
                            removeMedia={props.removeMedia}/>
                    );
                }

                return (
                    <SortableItem key={hash} className="draggableThumb">
                        {thumb}
                    </SortableItem>
                );
            })}
        </SortableList>
    )
};

export default ThumbnailList;
